// ko韩国
export default {
    CustomSelect: {
        '请选择': '선택하세요',
    },
    TopNav: {
        '创作者': '크리에이터',
        '游客': '방문객',
        '请登录后体验完整功能': '전체 기능을 이용하려면 로그인하세요',
        '登录': '로그인',
        '免费试用': '무료 체험',
        '退出登录': '로그아웃',
        '个人中心': '내 계정',
        '我的视频': '내 비디오',
        '额度管理': '크레딧 관리',
        '首页': '홈',
        'AI创作': 'AI 창작',
        '多参考': '다중 참조',
        '文本视频': '텍스트를 비디오로',
        '图片视频': '이미지를 비디오로',
        '文生图': '텍스트를 이미지로',
        '图生图': '이미지를 이미지로',
        '会员中心': '멤버십 센터',
        '概览': '개요',
        '我的创作': '내 작품',
        '账单管理': '청구서 관리',
        '生成任务': '생성 작업',
        '价格': '가격',
        '新闻资讯': '뉴스',
        '确定要退出登录吗？': '로그아웃하시겠습니까?',
        '提示': '힌트',
        '确定': '확인',
        '取消': '취소',
        '退出成功': '로그아웃되었습니다',
        '视频展示': '비디오 전시'
    },
    AiLayout: {
        'AI创作中心': 'AI 창작 센터',
        '视频生成': '비디오 생성',
        '图片生成': '이미지 생성',
        '我的作品': '내 작품',
        '我的创作': '내 작품',
        '今日剩余额度': '오늘 남은 크레딧',
        '多参考': '다중 참조',
        '文本视频': '텍스트를 비디오로',
        '图片视频': '이미지를 비디오로',
        '文生图': '텍스트를 이미지로',
        '图生图': '이미지를 이미지로',
    },
    HomeLayout: {
        '下一代AI视频生成平台': '차세대 AI 비디오 생성 플랫폼, 아이디어를 즉시 현실로',
        '产品': '제품',
        'AI视频': 'AI 비디오',
        '价格方案': '가격 플랜',
        '新闻资讯': '뉴스',
        '支持': '지원',
        '帮助中心': '고객센터',
        'API文档': 'API 문서',
        '常见问题': '자주 묻는 질문',
        '法律': '법적 고지',
        '服务条款': '이용약관',
        '隐私政策': '개인정보처리방침',
        '使用协议': '사용 계약',
        '版权所有': '저작권 소유',
        '客服邮箱': '고객지원 이메일',
        '复制邮箱': '이메일 복사',
        '开发中': '개발 중입니다, 기대해주세요!',
        '链接已复制到剪贴板': '링크가 클립보드에 복사되었습니다',
    },
    MyLayout: {
        '创作者': '크리에이터',
        '退出登录': '로그아웃',
        '概览': '개요',
        '我的创作': '내 작품',
        '会员中心': '멤버십 센터',
        '额度管理': '크레딧 관리',
        '账单管理': '청구서 관리',
        '生成任务': '생성 작업',
        '确定要退出登录吗？': '로그아웃하시겠습니까?',
        '提示': '힌트',
        '确定': '확인',
        '取消': '취소',
        '退出成功': '로그아웃되었습니다'
    },
    Image: {
        "文本生成图片": "텍스트를 이미지로",
        "图片生成图片": "이미지를 이미지로",
        "用文字描述": "원하는 화면을 글로 설명하세요",
        "上传图片素材": "이미지 소재 업로드, 다중 이미지 생성 지원",
        "图片描述": "이미지 설명",
        "描述您想要的图片": "생성하려는 이미지 내용을 자세히 설명하세요 (한국어 또는 영어 가능)",
        "提示描述越详细效果越好": "힌트: 설명이 자세할수록 생성 결과가 더 좋아집니다",
        "图片素材": "이미지 소재",
        "预览图片": "미리보기",
        "上传图片": "이미지 업로드",
        "支持格式JPGPNG": "JPG, PNG 형식 지원",
        "最多": "최대",
        "张图片": "장",
        "超过大小限制": "10MB 제한 초과",
        "不是图片文件": "유효한 이미지 파일이 아닙니다",
        "最多上传": "최대 업로드",
        "请先上传图片": "먼저 이미지 소재를 업로드하세요",
        "请选择要生成的图片": "생성할 이미지를 선택하세요",
        "生成结果": "생성 결과",
        "重新生成成功": "재생성 성공",
        "模型": "AI 모델",
        "请选择模型": "생성 모델을 선택하세요",
        "分辨率": "출력 해상도",
        "请选择分辨率": "해상도를 선택하세요",
        "图片比例": "화면 비율",
        "补充描述": "추가 설명 (선택사항)",
        "补充描述提示": "선택사항: 이미지에 포함할 추가 효과나 스타일을 설명하세요",
        "开始绘制": "그리기 시작",
        "开始生成": "생성 시작",
        "生成中": "생성 중입니다, 잠시만 기다려주세요...",
        "生成成功": "생성 성공",
        "图片生成成功": "이미지가 성공적으로 생성되었습니다!",
        "作品已保存到我的作品": "작품이 '내 작품'에 저장되었습니다",
        "继续创作": "계속 창작하기",
        "查看作品": "작품 보기",
        "请输入图片描述": "이미지 설명을 입력하세요"
    },
    MyCreation: {
        '我的创作': '내 작품',
        '查看和管理您的所有作品': '모든 작품 보기 및 관리',
        '预览': '미리보기',
        '下载': '다운로드',
        '编辑': '편집',
        '分享': '공유',
        '删除': '삭제',
        '暂无作品': '작품이 없습니다',
        '去创作': '창작하러 가기',
        '确定删除': '삭제 확인',
        '确定要删除作品': '작품을 삭제하시겠습니까',
        '吗？': '?',
        '此操作不可恢复': '이 작업은 되돌릴 수 없습니다, 신중하게 진행하세요!',
        '取消': '취소',
        '分享作品': '작품 공유',
        '复制链接': '링크 복사',
        '全部': '전체',
        '视频': '비디오',
        '图片': '이미지',
        '正在下载:': '다운로드 중: ',
        '链接已复制到剪贴板': '링크가 클립보드에 복사되었습니다',
        '删除成功': '삭제되었습니다'
    },
    Video: {
        "文本生成视频": "텍스트를 비디오로",
        "图片生成视频": "이미지를 비디오로",
        "智能视频生成": "지능형 비디오 생성",
        "输入文字描述": "텍스트 설명 입력",
        "上传1-9张图片": "1-9장의 이미지 업로드",
        "上传图片视频音频": "이미지/비디오/오디오 업로드",
        "视频描述": "비디오 설명",
        "描述您想要的视频场景": "원하는 비디오 장면 설명",
        "提示": "힌트",
        "图片素材": "이미지 소재",
        "最多上传": "최대 업로드",
        "张": "장",
        "预览": "미리보기",
        "上传图片": "이미지 업로드",
        "支持格式": "JPG, PNG 형식 지원, 파일당 최대 10MB, 최대",
        "AI": "AI가 지능적으로 융합하여 부드러운 전환 효과를 생성합니다",
        "动态描述": "움직임 설명",
        "描述您希望图片如何动起来": "이미지가 어떻게 움직이길 원하는지 설명하세요",
        "个": "개",
        "上传视频": "비디오 업로드",
        "上传音频": "오디오 업로드",
        "描述您希望视频呈现的效果": "원하는 비디오 효과를 설명하세요",
        "模型": "모델",
        "请选择模型": "모델을 선택하세요",
        "分辨率": "해상도",
        "请选择分辨率": "해상도를 선택하세요",
        "宽高比": "화면 비율",
        "视频时长": "비디오 길이",
        "生成音频": "오디오 생성",
        "开启音效": "음향 효과 켜기",
        "静音模式": "무음 모드",
        "音频提示": "힌트: 업로드한 오디오는 배경 음악으로 사용됩니다. 오디오를 업로드하지 않으면 AI가 자동으로 음악을 생성합니다",
        "开始生成": "생성 시작",
        "积分": "포인트",
        "生成中": "생성 중",
        "生成成功": "생성 성공",
        "视频生成成功！": "비디오가 성공적으로 생성되었습니다!",
        "作品已保存到": "작품이 '내 작품'에 저장되었습니다",
        "继续创作": "계속 창작하기",
        "查看作品": "작품 보기",
        "视频预览": "비디오 미리보기",
        "关闭": "닫기",
        "下载视频": "비디오 다운로드",
        "您的浏览器不支持视频播放": "브라우저가 비디오 재생을 지원하지 않습니다",
        "生成进度": "생성 진행률",
        "描述": "설명",
        "时长": "길이",
        "秒": "초",
        "视频素材": "비디오 소재",
        "音频素材": "오디오 소재",
        "双图融合模式": "이중 이미지 융합 모드",
        "开始下载视频": "비디오 다운로드 시작",
        "请输入视频描述": "비디오 설명을 입력하세요",
        "请至少上传一张图片": "최소 한 장의 이미지를 업로드하세요",
        "请至少上传一张图片或一个视频": "최소 한 장의 이미지 또는 하나의 비디오를 업로드하세요",
        "最多只能上传": "최대 업로드",
        "超过": "초과",
        "限制": "제한",
        "不是图片文件": "유효한 이미지 파일이 아닙니다",
        "不是视频文件": "유효한 비디오 파일이 아닙니다",
        "不是音频文件": "유효한 오디오 파일이 아닙니다"
    },
    Forgot: {
        "找回密码": "비밀번호 찾기",
        "请输入您的邮箱，我们将发送验证码": "이메일을 입력하시면 인증번호를 보내드립니다",
        "密码重置成功，请使用新密码登录": "비밀번호가 재설정되었습니다. 새 비밀번호로 로그인하세요",
        "密码重置成功": "비밀번호 재설정 성공",
        "您的密码已成功重置，请使用新密码登录": "비밀번호가 성공적으로 재설정되었습니다. 새 비밀번호로 로그인하세요",
        "立即登录": "바로 로그인",
        "邮箱": "이메일",
        "请输入注册邮箱": "등록된 이메일을 입력하세요",
        "发送验证码": "인증번호 보내기",
        "请输入验证码": "인증번호를 입력하세요",
        "验证码": "인증번호",
        "新密码": "새 비밀번호",
        "设置新密码": "새 비밀번호 설정",
        "确认新密码": "새 비밀번호 확인",
        "再次输入新密码": "새 비밀번호를 다시 입력하세요",
        "重置密码": "비밀번호 재설정",
        "返回登录": "로그인으로 돌아가기",
        "验证中": "인증 중",
        "重置中": "재설정 중",
        "弱": "약함",
        "中": "보통",
        "强": "강함",
        "请输入邮箱地址": "이메일 주소를 입력하세요",
        "请输入正确的邮箱格式": "올바른 이메일 형식을 입력하세요",
        "验证码应为6位数字": "인증번호는 6자리 숫자여야 합니다",
        "请输入新密码": "새 비밀번호를 입력하세요",
        "密码至少需要6位": "비밀번호는 최소 6자리 이상이어야 합니다",
        "请再次输入新密码": "새 비밀번호를 다시 입력하세요",
        "两次输入的密码不一致": "입력한 비밀번호가 일치하지 않습니다",
        "验证码已发送": "인증번호가 발송되었습니다"
    },
    Login: {
        "下一代AI视频生成平台": "차세대 AI 비디오 생성 플랫폼",
        "一键生成": "원클릭 생성",
        "支持4K超高清输出": "4K 초고화질 출력 지원",
        "多种风格模板任选": "다양한 스타일 템플릿 선택 가능",
        "商用授权无忧使用": "상업용 라이선스, 걱정 없는 사용",
        "欢迎回来": "돌아오신 것을 환영합니다",
        "登录您的账号继续创作": "로그인하여 창작을 계속하세요",
        "邮箱": "이메일",
        "请输入邮箱地址": "이메일 주소를 입력하세요",
        "密码": "비밀번호",
        "请输入您的密码": "비밀번호를 입력하세요",
        "记住我": "로그인 상태 유지",
        "忘记密码？": "비밀번호를 잊으셨나요?",
        "登录": "로그인",
        "登录中": "로그인 중",
        "还没有账号？": "아직 계정이 없으신가요?",
        "立即注册": "지금 가입하기",
        "请输入正确的邮箱格式": "올바른 이메일 형식을 입력하세요",
        "请输入密码": "비밀번호를 입력하세요",
        "密码至少需要6位": "비밀번호는 최소 6자리 이상이어야 합니다",
        "密码不能超过20位": "비밀번호는 20자를 초과할 수 없습니다",
        "登录成功": "로그인되었습니다"
    },
    Register: {
        "创建账号": "계정 만들기",
        "开始您的AI视频创作之旅": "AI 비디오 창작 여정을 시작하세요",
        "姓名": "이름",
        "请输入您的姓名": "이름을 입력하세요",
        "邮箱": "이메일",
        "请输入邮箱地址": "이메일 주소를 입력하세요",
        "获取验证码": "인증번호 받기",
        "验证码": "인증번호",
        "请输入验证码": "인증번호를 입력하세요",
        "密码": "비밀번호",
        "设置密码": "비밀번호 설정",
        "确认密码": "비밀번호 확인",
        "再次输入密码": "비밀번호 다시 입력",
        "我已阅读并同意": "다음 내용을 읽었으며 동의합니다",
        "服务条款": "이용약관",
        "和": "및",
        "隐私政策": "개인정보처리방침",
        "注册中": "가입 중",
        "已有账号？": "이미 계정이 있으신가요?",
        "立即登录": "바로 로그인",
        "弱": "약함",
        "中": "보통",
        "强": "강함",
        "请输入姓名": "이름을 입력하세요",
        "姓名至少需要2个字符": "이름은 최소 2자 이상이어야 합니다",
        "姓名不能超过20个字符": "이름은 20자를 초과할 수 없습니다",
        "请输入正确的邮箱格式": "올바른 이메일 형식을 입력하세요",
        "验证码应为6位数字": "인증번호는 6자리 숫자여야 합니다",
        "请输入密码": "비밀번호를 입력하세요",
        "密码至少需要6位": "비밀번호는 최소 6자리 이상이어야 합니다",
        "密码不能超过20位": "비밀번호는 20자를 초과할 수 없습니다",
        "请再次输入密码": "비밀번호를 다시 입력하세요",
        "两次输入的密码不一致": "입력한 비밀번호가 일치하지 않습니다",
        "验证码已发送": "인증번호가 발송되었습니다",
        "注册成功": "가입되었습니다"
    },
    Faq: {
        '常见问题': '자주 묻는 질문',
        '您在使用过程中遇到的问题': '이용 중 발생하는 문제들에 대한 답변을 여기서 찾으세요',
        '搜索您的问题': '질문 검색...',
        '没有找到相关的问题': '관련 질문을 찾을 수 없습니다',
        '查看全部问题': '모든 질문 보기',
        '没有找到您想要的答案？': '원하는 답변을 찾지 못하셨나요?',
        '我们的客服团队随时为您提供帮助': '고객 지원팀이 항상 도와드릴 준비가 되어 있습니다',
        '复制客服邮箱': '고객지원 이메일 복사',
        '链接已复制到剪贴板': '링크가 클립보드에 복사되었습니다'
    },
    Home: {
        '立即订阅': '지금 구독하기',
        'AI视频生成新时代': 'AI 비디오 생성의 새로운 시대',
        '用文字创造': '글로 창작하기',
        '无限视频': '무제한 비디오',
        '让每个人都能成为视频创作者': '누구나 비디오 크리에이터가 될 수 있습니다. 텍스트 설명만 입력하면 고품질의 독특한 AI 비디오를 생성할 수 있습니다.',
        '免费开始': '무료 시작',
        '观看演示': '데모 보기',
        'AI生成': 'AI 생성',
        'AI视频': 'AI 비디오',
        '三步轻松生成专业视频': '세 단계로 전문적인 비디오를 쉽게 생성',
        '输入提示词': '프롬프트 입력',
        '用文字描述您想要的视频内容': '원하는 비디오 내용을 글로 설명하세요. 자세할수록 효과가 좋습니다',
        '智能生成': '지능형 생성',
        'AI模型自动理解并创作': 'AI 모델이 자동으로 이해하고 창작합니다. 몇 분 안에 렌더링이 완료됩니다',
        '下载作品': '작품 다운로드',
        '高清视频生成完成': '고화질 비디오 생성 완료, 즉시 다운로드하여 사용하세요',
        'AI视频生成': 'AI 비디오 생성',
        '精彩视频': '텍스트 설명을 입력하면 AI가 멋진 비디오를 생성합니다',
        '描述您想要的视频场景': '원하는 비디오 장면을 설명하세요. 예: 벚꽃나무 아래에서 놀고 있는 고양이, 꽃잎 사이로 비치는 햇살...',
        '生成中': '생성 중...',
        '生成视频': '비디오 생성',
        'AI图片': 'AI 이미지',
        '精美图片': '텍스트 설명을 입력하면 AI가 멋진 이미지를 생성합니다',
        '描述您想要的图片场景': '원하는 이미지 장면을 설명하세요. 예: 미래 도시의 스카이라인, 반짝이는 네온사인, 사이버펑크 스타일...',
        '生成图片': '이미지 생성',
        '强大功能': '강력한 기능',
        '让视频创作变得简单有趣': '비디오 창작을 간단하고 재미있게',
        '案例展示': '사례 소개',
        '来看看用户使用': '사용자들이 만든 멋진 작품을 감상해보세요',
        '创作的精彩作品': '사용자 작품',
        '新闻资讯': '뉴스',
        '了解': '최신 소식 보기',
        '的最新动态和产品更新': '의 최신 뉴스 및 제품 업데이트',
        '查看更多': '더 보기',
        '热门': '인기',
        '最新': '최신',
        '阅读更多': '더 읽기',
        '选择适合您的方案': '당신에게 맞는 플랜 선택',
        '灵活的定价': '다양한 니즈를 만족시키는 유연한 가격',
        '视频预览': '비디오 미리보기',
        '生成成功': '생성 성공',
        '作品已保存到': "작품이'내 작품'에 저장되었습니다",
        '继续创作': '계속 창작하기',
        '查看作品': '작품 보기',
        '请输入视频描述': '비디오 설명을 입력하세요',
        '视频生成成功！': '비디오가 성공적으로 생성되었습니다!',
        '请输入图片描述': '이미지 설명을 입력하세요',
        '图片生成成功！': '이미지가 성공적으로 생성되었습니다!',
    },
    News: {
        '新闻资讯': '뉴스',
        '了解': '최신 소식 보기',
        '的最新动态和产品更新': '의 최신 뉴스 및 제품 업데이트',
        '精选': '선택됨',
        '阅读': '읽기',
        '点赞': '좋아요',
        '热门': '인기',
        '最新': '최신',
        '阅读更多': '더 읽기',
        '加载中': '로딩 중...',
        '暂无新闻': '뉴스가 없습니다',
        '清除筛选': '필터 초기화',
        '加载新闻失败': '뉴스를 불러오지 못했습니다. 나중에 다시 시도하세요',
    },
    Price: {
        '选择适合您的方案': '당신에게 맞는 플랜 선택',
        '灵活的定价': '다양한 니즈를 만족시키는 유연한 가격',
        '包月': '월간',
        '包年': '연간',
        '购买积分': '크레딧 구매',
        '只需要几个视频': '몇 개의 비디오만 필요하신가요? 구독 없이 크레딧 팩을 직접 구매하세요',
        '产品大全': '제품 전체보기',
        '了解': '자세히 보기',
        '全系列产品的详细信息和支付方式': '전체 제품 시리즈의 상세 정보 및 결제 방법'
    },
    Billing: {
        '账单管理': '청구서 관리',
        '账户余额': '계정 잔액',
        '本月支出': '이번 달 지출',
        '订单数量': '주문 수량',
        '账单列表': '청구서 목록',
        '请选择类型': '유형을 선택하세요',
        '请选择时间范围': '시간 범위를 선택하세요',
        '订单号': '주문번호',
        '类型': '유형',
        '金额': '금액',
        '状态': '상태',
        '时间': '시간',
        '操作': '작업',
        '查看详情': '상세 보기',
        '下载发票': '송장 다운로드',
        '暂无作品': '작품이 없습니다',
        '去创作': '창작하러 가기',
        '支付方式': '결제 방법',
        '添加支付方式': '결제 방법 추가',
        '默认': '기본값',
        '设为默认': '기본값으로 설정',
        '编辑': '편집',
        '删除': '삭제',
        '账单详情': '청구서 상세',
        '交易流水号': '거래 번호',
        '关闭': '닫기',
        '账号': '계좌번호/카드번호',
        '请输入账号或卡号': '계좌번호 또는 카드번호를 입력하세요',
        '姓名': '이름',
        '请输入持卡人姓名': '카드 소유자 이름을 입력하세요',
        '有效期': '유효기간',
        '请输入CVV码': 'CVV 코드를 입력하세요',
        '取消': '취소',
        '确认添加': '추가 확인',
        '确认修改': '수정 확인',
        '确认删除': '삭제 확인',
        '编辑支付方式': '결제 방법 편집',
        '确定要删除支付方式': '이 결제 방법을 삭제하시겠습니까?',
        '删除后不可恢复': '삭제 후 복구할 수 없습니다, 신중하게 진행하세요!',
        '请输入账号': '계좌번호/카드번호를 입력하세요',
        '添加成功': '추가되었습니다',
        '修改成功': '수정되었습니다',
        '已设为默认支付方式': '기본 결제 방법으로 설정되었습니다',
        '删除成功': '삭제되었습니다',
    },
    Credit: {
        '额度管理': '크레딧 관리',
        '当前可用额度': '현재 사용 가능한 크레딧',
        '升级会员': '멤버십 업그레이드',
        '本月已用': '이번 달 사용량',
        '视频生成': '비디오 생성',
        'AI图片': 'AI 이미지',
        '其他': '기타',
        '购买额度包': '크레딧 팩 구매',
        '最受欢迎': '가장 인기 있음',
        '额度': '크레딧',
        '立即购买': '지금 구매',
        '使用记录': '사용 기록',
        '操作': '작업',
        '类型': '유형',
        '额度变动': '크레딧 변동',
        '时间': '시간',
        '购买': '구매',
        '确认购买': '구매 확인',
        '金额': '금액: ',
        '获得': '획득',
        '取消': '취소',
        '今天': '오늘',
        '昨天': '어제',
    },
    Dashboard: {
        '欢迎回来': '돌아오신 것을 환영합니다,',
        '创建新视频': '새 비디오 만들기',
        '本月生成次数': '이번 달 생성 횟수',
        '剩余额度': '남은 크레딧',
        '总视频数': '총 비디오 수',
        '会员状态': '멤버십 상태',
        '最近生成': '최근 생성',
        '查看全部': '전체 보기',
        '视频预览': '비디오 미리보기',
        '视频生成中': '비디오 생성 중입니다. 미리보기까지 잠시만 기다려주세요',
    },
    Membership: {
        '会员中心': '멤버십 센터',
        '当前方案': '현재 플랜',
        'Pro 会员': 'Pro 멤버십',
        '专业创作者首选': '전문 크리에이터를 위한 최고의 선택',
        '月': '개월',
        '会员有效期': '멤버십 유효기간',
        '剩余天数': '남은 일수',
        '续费会员': '멤버십 연장',
        '取消订阅': '구독 취소',
        '本月使用情况': '이번 달 사용 현황',
        '视频生成': '비디오 생성',
        '次': '회',
        '额度使用': '크레딧 사용량',
        '快速生成': '빠른 생성',
        '升级方案': '플랜 업그레이드',
        '联系销售': '영업 문의',
        '会员权益': '멤버십 혜택',
        '续费后将延长会员有效期30天': '연장 시 멤버십이 30일 연장됩니다',
        '取消': '취소',
        '确认续费': '연장 확인',
        '取消后您将失去所有会员权益': '취소 후 모든 멤버십 혜택을 잃게 되며, 남은 크레딧은 유지됩니다',
        '再想想': '다시 생각하기',
        '确认取消': '취소 확인',
        '姓名': '이름',
        '请输入您的姓名': '이름을 입력하세요',
        '请输入姓名': '이름을 입력하세요',
        '公司': '회사명',
        '请输入公司名称': '회사명을 입력하세요',
        '邮箱': '이메일',
        '请输入邮箱地址': '이메일 주소를 입력하세요',
        '请输入邮箱': '이메일을 입력하세요',
        '请输入正确的邮箱格式': '올바른 이메일 형식을 입력하세요',
        '需求': '요청사항',
        '请描述您的需求': '요청사항을 설명하세요',
        '提交': '제출',
        '请填写需求': '요청사항을 입력하세요',
        '续费成功': '연장되었습니다! 멤버십 기간이 연장되었습니다',
        '已取消订阅': '구독이 취소되었습니다. 만료 후 멤버십이 종료됩니다',
        '提交成功': '제출되었습니다. 곧 연락드리겠습니다!',
    },
    Task: {
        '生成任务': '생성 작업',
        '新建任务': '새 작업',
        '进行中': '진행 중',
        '已完成': '완료됨',
        '失败': '실패',
        '队列中': '대기 중',
        '活跃任务': '활성 작업',
        '刷新': '새로고침',
        '暂无活跃任务': '활성 작업이 없습니다',
        '预计剩余': '예상 잔여 시간',
        '暂停': '일시 중지',
        '继续': '계속',
        '取消': '취소',
        '最近完成': '최근 완료',
        '查看全部': '전체 보기',
        '暂无完成的任务': '완료된 작업이 없습니다',
        '播放': '재생',
        '下载': '다운로드',
        '分享': '공유',
        '确认取消': '취소 확인',
        '确定要取消任务吗': '작업을 취소하시겠습니까?',
        '已消耗的额度将无法退还': '소비된 크레딧은 환불되지 않습니다',
        '返回': '돌아가기',
        '分享作品': '작품 공유',
        '复制链接': '링크 복사',
        '任务列表已刷新': '작업 목록이 새로고침되었습니다',
        '已暂停': '일시 중지됨',
        '生成中': '생성 중',
        '已恢复': '재개됨',
        '任务已取消': '작업이 취소되었습니다',
        '链接已复制到剪贴板': '링크가 클립보드에 복사되었습니다',
    },
    VideoShow: {
        '示例': '예시',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': '데모 라이브러리에서 엄선한 클립 모음입니다. 카드를 클릭하면 유사한 스타일의 콘텐츠 생성을 시작할 수 있습니다.',
        '全部': '전체',
        '电影感': '시네마틱',
        '角色': '캐릭터',
        '产品': '제품',
        '自然': '자연',
        '趣味': '재미있는',
        '加载中': '로딩 중',
        '暂无展示': '사용 가능한 데모 없음',
        '视频预览': '동영상 미리보기',
    },
    Request: {
        '加载中': '로딩 중...',
        '您已退出登录': '로그아웃되었습니다. 다시 로그인할 수 있습니다',
        '确认退出': '로그아웃 확인',
        '重新登录': '다시 로그인',
        '错误': '오류',
        '网络错误': '네트워크 오류',
        '下载中': '다운로드 중...'
    },
    Other: {
        '剩余额度': '잔여 금액',
        '去登录': '로그인하기',
        '请登录后查看': '로그인 후 조회 가능합니다',
        '任务': '작업',
        '可在「生成任务」中查看详情': '，"생성 작업"에서 자세한 내용을 확인할 수 있습니다',
        '查看详情': '자세히 보기',
        '排队中': '대기 중',
        '运行中': '실행 중',
        '取消': '취소',
        '成功': '성공',
        '失败': '실패',
        '超时': '시간 초과',
        '最后更新': '마지막 업데이트:',
        '视频生成': '비디오 생성',
        '活跃用户': '활성 사용자',
        '用户评分': '사용자 평점',
        '万': '만',
        '快速生成': '빠른 생성',
        '先进的AI模型': '첨단 AI 모델로 몇 분 만에 고품질 비디오 생성',
        '多种风格': '다양한 스타일',
        '多种风格任您选择': '리얼리스틱, 애니메이션, 아트 등 다양한 스타일 중 선택 가능',
        '高清输出': '고화질 출력',
        '支持4K超高清视频输出': '4K 초고화질 비디오 출력 지원, 디테일이 선명하게 보입니다',
        '商用授权': '상업적 라이선스',
        '生成的视频可用于商业用途': '생성된 비디오는 상업적 용도로 사용 가능, 저작권 걱정 없음',
        '原价': '원래 가격',
        '积分价格说明': '크레딧 가격 설명',
        '系列': '시리즈',
        '模型': '모델',
        '分辨率': '해상도',
        '积分': '크레딧',
        '秒': '초',
        '秒示例': '초 (예시)',
        '图片模型': '이미지 모델',
        '图片为': '이미지는',
        '系列产品': '시리즈 제품, 현재 지원',
        '支持使用任意机型查看完整体验': '，모든 기기에서 전체 경험을 볼 수 있습니다.',
        '计费方式': '과금 방식',
        '张': '장',
        '按生成张数计费': '생성 장수별 과금',
        '普通用户': '일반 사용자',
        '无记录': '기록 없음',
        '总支出': '총 지출',
        '月总使用': '월간 총 사용량',
        '月视频使用': '월간 비디오 사용량',
        '月图片使用': '월간 이미지 사용량',
        '生成成功': '생성 성공',
        '视频总生成': '총 비디오 생성 수',
        '图片总生成': '총 이미지 생성 수',
        '生成中': '생성 중입니다. 1~3분 기다려주세요',
        '来自我们演示库的一套精心挑选的剪辑片段': '데모 라이브러리에서 엄선한 클립 모음입니다.',
        '最近7天': '최근 7일',
        '最近30天': '최근 30일',
        '本月': '이번 달',
        '上月': '지난달',
    }
}